// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"803421a1","845":"0ffebb09"}[chunkId] + ".chunk.js";
};